import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  container: {
    marginBottom: '0',
    alignSelf: 'flex-start',
    width: '100%',
    padding: '0 16px 16px',
    boxSizing: 'border-box',
  },
  label: {
    fontSize: Theme.typography.size[2],
    color: Theme.palette.gray[750],
    margin: '0 0 8px 0',
  },
  tabRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    marginBottom: '-1px',
    height: 'max-content',
    [Theme.breakpoints.down('sm')]: {
      gap: '4px',
    },
  },
  tab: {
    flex: 1,
    cursor: 'pointer',
    padding: 0,
    border: `1px solid ${Theme.palette.gray[250]}`,
    borderRadius: 4,
    backgroundColor: '#fff',
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    transition: 'background-color 0.15s',
    outline: 'none',
    overflow: 'hidden',
    marginBottom: '8px',
    '&:hover': {
      backgroundColor: Theme.palette.gray[50] || '#fafafa',
    },
  },
  tabContent: {
    padding: '12px 12px 10px',
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
  },
  tabInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minWidth: 0,
  },
  tabSelected: {
    backgroundColor: '#EFF0F1',
    borderBottom: 'none',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    marginBottom: 0,
    '&:hover': {
      backgroundColor: '#EFF0F1',
    },
  },
  colorStripe: {
    height: '8px',
    flexShrink: 0,
    alignSelf: 'stretch',
  },
  stripeUnavailable: { backgroundColor: Theme.palette.gray[200] },
  tabUnavailable: {
    cursor: 'not-allowed',
    backgroundColor: Theme.palette.gray[50] || '#fafafa',
    '&:hover': {
      backgroundColor: Theme.palette.gray[50] || '#fafafa',
    },
  },
  notAvailableLabel: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px 12px',
    fontSize: Theme.typography.size[1],
    color: Theme.palette.gray[400],
    textAlign: 'center',
    whiteSpace: 'normal',
  },
  cabinName: {
    display: 'block',
    fontWeight: 600,
    fontSize: Theme.typography.size[2],
    color: Theme.palette.gray[900] || '#212121',
    marginBottom: '4px',
    [Theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  cabinNameShort: {
    display: 'none',
    fontWeight: 600,
    fontSize: Theme.typography.size[1],
    color: Theme.palette.gray[900] || '#212121',
    marginBottom: '4px',
    [Theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  onSaleChip: {
    alignSelf: 'flex-start',
    flexShrink: 0,
    height: '20px',
    fontSize: Theme.typography.size[0],
    backgroundColor: '#F5E8FB',
    color: '#5F1477',
    border: '1px solid #E3B7F1',
    fontWeight: 600,
    borderRadius: '12px',
    '& .MuiChip-label': { padding: '0 10px' },
  },
  onSaleChipCelebrity: {
    alignSelf: 'flex-start',
    flexShrink: 0,
    height: '20px',
    fontSize: Theme.typography.size[0],
    backgroundColor: '#E8F3F4',
    color: '#275B63',
    fontWeight: 700,
    borderRadius: 0,
    clipPath: 'polygon(8px 0, 100% 0, calc(100% - 8px) 100%, 0 100%)',
    '& .MuiChip-label': { padding: '0 14px' },
  },
  fromRow: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '4px',
    [Theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '2px',
    },
  },
  fromLabel: {
    fontSize: Theme.typography.size[1],
    color: Theme.palette.gray[750],
  },
  lowestPrice: {
    fontSize: Theme.typography.size[2],
    fontWeight: 600,
    color: Theme.palette.gray[900] || '#212121',
    [Theme.breakpoints.down('sm')]: {
      fontSize: Theme.typography.size[1],
    },
  },
  fareSection: {
    borderRadius: '0 4px 4px 4px',
    border: '1px solid #BEC9DD',
    backgroundColor: '#EFF0F1',
    display: 'flex',
    padding: '8px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
  },
  chooseFareLabel: {
    fontSize: Theme.typography.size[2],
    color: Theme.palette.gray[750],
    margin: '0 0 12px 0',
  },
}));

export default useStyles;
